var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17678 0.82713C6.27441 0.924761 6.27441 1.08305 6.17678 1.18068L3.35355 4.00391L6.17678 6.82713C6.27441 6.92476 6.27441 7.08305 6.17678 7.18068C6.07915 7.27831 5.92085 7.27831 5.82322 7.18068L2.82322 4.18068C2.72559 4.08305 2.72559 3.92476 2.82322 3.82713L5.82322 0.82713C5.92085 0.729498 6.07915 0.729498 6.17678 0.82713Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.b3b7f91ff1bb54e41e59372e262f983b.svg";
export { ForwardRef as ReactComponent };